import { post, postJson } from '@/utils/request';

/******** 首页统计 Start ********/
export const getEntrustmentCntByMonthForYear = params => {
  return post(`/app/da/getEntrustmentCntByMonthForYear`, params);
};
export const getSampleCntDABySampleType = params => {
  return post(`/app/da/getSampleCntDABySampleType`, params);
};
export const getSampleCntDAByTestUser = params => {
  return post(`/app/da/getSampleCntDAByTestUser`, params);
};
// 待办事项
export const getMtApplyCount = params => {
  return post(`/app/getMtApplyCount`, params);
};
/******** 首页统计 End ********/
